import { render, staticRenderFns } from "./xinde.vue?vue&type=template&id=bfae5740&"
import script from "./xinde.vue?vue&type=script&lang=js&"
export * from "./xinde.vue?vue&type=script&lang=js&"
import style0 from "./xinde.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports